import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-change-status-question',
  templateUrl: './change-status-question.component.html',
  styleUrls: ['./change-status-question.component.css']
})
export class ChangeStatusQuestionComponent implements OnInit {

  api_error: any;
  api_success: string;
  acc_id;
  acc_status;
  question_id;
  statusTo: string;
  disableConfirmbtn = false;
  changeStatus;
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private accountService: AccountService) { }

  ngOnInit() {
    this.acc_id = this.data.account;
    this.acc_status = this.data.status;
    this.question_id = this.data.id;
    if (this.acc_status === 'ACTIVE') {
      this.statusTo = 'INACTIVE';
    } else {
      this.statusTo = 'ACTIVE';
    }
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onConfirm() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    this.accountService.changeQuestionStatus(this.acc_id,this.statusTo,this.question_id)
    .subscribe(
      data => {
        this.api_success = 'Status changed Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
      this.disableConfirmbtn = false;
      this.api_error = error.error;
      }
    );

  }
}
